import { matchPath } from "react-router-dom";
import { LANGUAGES_ARRAY } from "../constants/languages";

export function detectLocaleFromUrl(): string | null {
  const path = window.location.pathname;
  const localeMatch = matchPath({ path: "/:locale/*" }, path);

  const locale = localeMatch?.params?.locale;

  if (locale && LANGUAGES_ARRAY.includes(locale)) {
    return locale;
  }

  return null;
}
